









































import AlbumReeditions from '@/components/Album/AlbumReeditions.vue';
import AlbumGallery from '@/components/Album/AlbumGallery.vue';
import AlbumCredits from '@/components/Album/AlbumCredits.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Album from '@/types/Album';

@Component({
  components: { AlbumGallery, AlbumReeditions, AlbumCredits },
})
export default class AlbumDetails extends Vue {
  @Prop(String) private readonly albumId!: string;

  private albums!: Array<Album>;
  private originalAlbums!: Array<Album>;
  private reeditedAlbums!: Array<Album>;

  public created() {
    try {
      const json = require(`@/data/albums/${this.albumId}.json`);
      this.albums = json;
      this.originalAlbums = this.albums.filter(
        album => album.isReedition === undefined || album.isReedition === false
      );
      this.reeditedAlbums = this.albums.filter(
        album => album.isReedition !== undefined && album.isReedition === true
      );
    } catch (e) {
      console.log('json is undefined : ' + e);
    }
  }

  get hasReeditions(): boolean {
    return this.reeditedAlbums.length > 0;
  }

  public goBack() {
    this.$router.back();
  }

  public coverPath(album: Album) {
    try {
      const img = require(`@/assets/albums/${this.albumId}/${album.cover}`);

      return img;
    } catch (e) {
      console.log(
        `No cover found for @/assets/albums/${this.albumId}/${album.cover}`
      );

      return `https://fakeimg.pl/320x450/?text=${this.albumId}`;
    }
  }

  public page(page: string) {
    return require(`@/assets/albums/${this.albumId}/${page}`);
  }

  public albumPage(album: Album) {
    if (album.pages) {
      return album.pages.map(x =>
        require(`@/assets/albums/${this.albumId}/${x}`)
      );
    }

    return undefined;
  }

  public getAlbumPages(album: Album) {
    let array: Array<Object> = [];
    if (album.pages && album.pages.length > 0) {
      album.pages.forEach(page => {
        try {
          array.push(require(`@/assets/albums/${this.albumId}/${page}`));
        } catch (e) {
          console.log(`Cannot load @/assets/albums/${this.albumId}/${page}`);
        }
      });
    }
    return array;
  }

  public formattedResume(album: Album) {
    return album.resume.replace(/\\n/g, '<br>');
  }
}
